import { RematchDispatch } from '@rematch/core';

import { User } from '../@types/user';
import UserService from '../services/UserService';

type State = {
  current: User;
  users: ReadonlyArray<User>;
  userFlowSignature: { identity: string; signature: string };
};

const model = {
  state: {} as State,
  reducers: {
    loaded: (state: State, payload: ReadonlyArray<User>) => {
      return { ...state, current: payload };
    },
    setSignature: (state: State, signature: string) => {
      return { ...state, userFlowSignature: signature };
    },
  },
  effects: (dispatch: RematchDispatch<any>) => ({
    async loadCurrentUser() {
      const response = await UserService.getCurrentUser();
      const user = response.data;
      dispatch.users.loaded(user);
      await dispatch.users.loadUserFlowSignature(user.id);
    },
    async loadUserFlowSignature(userID: string) {
      try {
        const response = await UserService.getUserFlowSignature(userID);
        dispatch.users.setSignature(response.data);
      } catch (error) {
        console.error('Error fetching Userflow signature:', error);
      }
    },
  }),
};

export default model;
